import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../Contexts/AuthContext";

const PublicRoute = ({ children }) => {
  const {isLoggedin} = useAuthContext();
  return isLoggedin ? <Navigate to={"/dashboard"} replace /> : children;
};

export default PublicRoute;
